var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Interceptors from './Interceptors/Interceptors';
import Options from './Utils/Options';
import Loader from './Loaders/Loader';
import Emitter from './Utils/Emitter';
import Logger from './Utils/Logger';
//import fetchIntercept from "fetch-intercept";
/**
 * @class
 * @description Core class for the p2p plugin. It includes the options, the websocket communication,
 * @exports CdnBalancer
 */
export default class CdnBalancer extends Emitter {
    /**
     * Constructs CdnBalancer.
     * @param {constructionOptions} constructionOptions JSON with the options to construct the balancer.
     */
    constructor(constructionOptions) {
        super();
        this.options = new Options(constructionOptions);
        this._loader = new Loader(this.options);
        this.interceptors = new Interceptors(this);
        var cdnBalancer = this;
        //sconsole.log("[NPAW] Register fetch interceptor 5");
        /* require('whatwg-fetch');
     
         if (!window.fetch) {
     
           console.log("Dosn'tt exist");
     
           try {
             require('whatwg-fetch');
     
             console.log("adding whatwg");
     
           } catch (err) {
             throw Error('No fetch available. Unable to register fetch-intercept');
           }
         }*/
        /*  window.fetch = (function (fetch) {
      
            console.log("AAA");
      
          })(window.fetch);
      */
        // global.fetch= fetch;
        // window.fetch= fetch;
        /*  const { fetch: originalFetch } = window;
          
          window.fetch = async (...args) {
      
          //      window.fetch = async function() {
      
                    console.log("[NPAW] Intercepting2");
               
                 //   let [resource, config] = args;
      
                    console.log("[NPAW] Intercepting2");
      
                    let response : any;
      
                    let url = "goole.com";// resource.toString();
                    let urlTest = url;
                    let originalUrl = url;
                    let byteLength = 0;
                    let dontRewrite:boolean = false;
      
                    if( url.includes("h264") && !url.includes("rnpaw")  )
                      console.log("urlt-> "+url);
      
      
                    if( urlTest && urlTest.includes("DONTREWRITE") ){
                      url = urlTest.replace("DONTREWRITE","");
                      originalUrl = originalUrl.replace("DONTREWRITE","");
                      urlTest = urlTest.replace("DONTREWRITE","");
                      dontRewrite = true
                      console.log("Don't rewrite "+url)
                    }
                
                    let splitted = urlTest.split('?');
                    urlTest = splitted[0];
      
              
                    console.log("Intercepting fetch ferry!");
              
                    if(  urlTest.endsWith(".mpd") || urlTest.endsWith(".mp4") || urlTest.endsWith(".m3u8") || urlTest.endsWith(".ts") || urlTest.endsWith(".m4s")  ){
      
                        let urlObject = new URL(urlTest);
                        const newUrl = cdnBalancer.simpleRequest(urlObject);
      
                        console.log("New url -> "+newUrl.toString());
      
                      // aaa  response = await originalFetch(newUrl, config);
                          
                        //  if( response )
                        if (!response.ok && ( response.status >300 || response.status<=200)  ) {
                              // 404 error handling
                              console.log("The request failed!");
                              return Promise.reject(response);
                        }else{
                              console.log("The request is working perfectly!");
                              return response;
                        }
      
                       
      
                    }
      
                    if( !response ){
      
      ///aaa                response = await originalFetch(resource, config);
                      
                      console.log("Retrying");
                      
                      //  if( response )
                      if (!response.ok && ( response.status >300 || response.status<=200)  ) {
                              // 404 error handling
                              return Promise.reject(response);
                      }
      
                    }
                  
                console.log("Retrying works perfectly");
                      
                return response;
            };
      
      */
        /*const unregister = fetchIntercept.register({
    
          request: function (url, config) {
           
            let urlTest = url;
            let originalUrl = url;
            let byteLength = 0;
            let dontRewrite:boolean = false;
    
            if( url.includes("h264") && !url.includes("rnpaw")  )
              console.log("urlt-> "+url);
    
    
            if( urlTest && urlTest.includes("DONTREWRITE") ){
              url = urlTest.replace("DONTREWRITE","");
              originalUrl = originalUrl.replace("DONTREWRITE","");
              urlTest = urlTest.replace("DONTREWRITE","");
              dontRewrite = true
              console.log("Don't rewrite "+url)
            }
        
            let splitted = urlTest.split('?');
            urlTest = splitted[0];
    
      
          
    
            console.log("Intercepting fetch ferry!");
            console.log(config);
            console.log("Intercepting fetch ferry 2");
    
            Object.defineProperty(config, 'npaw',             {writable: true} );
    
            config.npaw="true";
      
          if( config.method=="GET" && ( urlTest.endsWith(".mpd") || urlTest.endsWith(".mp4") || urlTest.endsWith(".m3u8") || urlTest.endsWith(".ts") || urlTest.endsWith(".m4s") ) ){
                let urlObject = new URL(urlTest);
                const newUrl = cdnBalancer.simpleRequest(urlObject);
    
                console.log("New url -> "+newUrl.toString());
    
                return [newUrl.toString(), config];
            }
    
            return [url, config];
          },
    
        
          requestError: function (error) {
    
            console.log("------------ERROR----------------");
            console.log(error);
    
            return Promise.reject(error);
          },
        
         response: function (response) {
    
    
          console.log("RESPONSE");
          console.log(response);
          console.log("RESPONSE2");
    
    
    
            const clonedResponse = response.clone();
            const json = () =>
              clonedResponse
                .json()
                .then((data) => ({ ...data, title: `Intercepted: ${data.title}` }));
        
            response.json = json;
            return response;
          },
        
          responseError: function (error) {
    
            console.log("------------ERROR RESPONSE----------------");
            console.log(error);
    
            return Promise.reject(error);
          },
       });
    */
        /*xhrPrototype.setRequestHeader = function(header, value) {
         if (!intercepted && headersLog) {
             headersLog[header] = value;
         }
     
         return proxied.setRequestHeader.apply(this, arguments);
     }   ;*/
        var send = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function (data, ...rest) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                let init = Date.now();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                let url = this.url;
                let segment = cdnBalancer.getLoader().getSegment(url);
                let p2p = false;
                if (segment)
                    p2p = !cdnBalancer.getLoader().P2PLoader.getRequested(segment === null || segment === void 0 ? void 0 : segment.id);
                if (!segment || !segment.rendition || !segment.rendition.targetDuration || segment.rendition.targetDuration <= 0)
                    p2p = false;
                if (!segment || !p2p) {
                    send.call(this, data);
                }
                else {
                    let storedSegment = cdnBalancer._loader.P2PLoader.getSegment(segment.id);
                    let data = storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data;
                    let ready = false;
                    let timeout = (((_a = segment.rendition) === null || _a === void 0 ? void 0 : _a.targetDuration) || 0) * 1000 / 2;
                    while (!ready) {
                        yield new Promise(f => setTimeout(f, 10));
                        storedSegment = cdnBalancer._loader.P2PLoader.getSegment(segment.id);
                        data = storedSegment === null || storedSegment === void 0 ? void 0 : storedSegment.data;
                        if (data)
                            ready = true;
                        if (Date.now() - init > timeout) {
                            ready = true;
                            data = undefined;
                        }
                    }
                    console.log((data === null || data === void 0 ? void 0 : data.byteLength) + " Processing P2P Segment for " + segment.id + " " + segment + " " + ((_b = segment.rendition) === null || _b === void 0 ? void 0 : _b.targetDuration) + " " + timeout);
                    //data = undefined; segment.rendition?.targetDuration 
                    if (data) {
                        let re = new CustomEvent('readystatechange');
                        let le = new CustomEvent('loadend');
                        let loade = new CustomEvent('load');
                        let loadStarte = new CustomEvent('loadstart');
                        Object.defineProperty(this, 'response', { writable: true });
                        // Object.defineProperty(this, 'responseText',       {writable: true} );  
                        Object.defineProperty(this, 'status', { writable: true });
                        Object.defineProperty(this, 'statusText', { writable: true });
                        Object.defineProperty(this, 'readyState', { writable: true });
                        Object.defineProperty(this, 'byteLength', { writable: true });
                        Object.defineProperty(this, 'responseURL', { writable: true });
                        Object.defineProperty(this, 'responseType', { writable: true });
                        this.dispatchEvent(re);
                        this.readyState = XMLHttpRequest.LOADING;
                        console.log("UPS A");
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore-next-line
                        this.byteLength = data.byteLength;
                        this.response = data;
                        this.status = 200;
                        this.statusText = 'OK';
                        this.readyState = XMLHttpRequest.DONE;
                        this.responseURL = url;
                        this.responseType = 'arraybuffer';
                        // this.dispatchEvent(loade);
                        this.dispatchEvent(re);
                        this.dispatchEvent(le);
                        console.log("UPS -> " + (Date.now() - init));
                    }
                    else {
                        let cdnUrl = segment.finalUrl;
                        console.log("BACKUP -> " + cdnUrl);
                        // cdnBalancer.openAndSend( this ,cdnUrl+"DONTREWRITE") ;
                        this.open("GET", cdnUrl + "DONTREWRITE");
                        this.send();
                        //send.apply(this); 
                    }
                }
            });
        };
        var open = XMLHttpRequest.prototype.open;
        //  Object.defineProperty(XMLHttpRequest.prototype, 'url',       {writable: true} );  
        XMLHttpRequest.prototype.open = function (method, url, ...rest) {
            let urlTest = url;
            let originalUrl = url;
            let byteLength = 0;
            let dontRewrite = false;
            if (url.includes("h264") && !url.includes("rnpaw"))
                console.log("urlt-> " + url);
            if (urlTest && urlTest.includes("DONTREWRITE")) {
                url = urlTest.replace("DONTREWRITE", "");
                originalUrl = originalUrl.replace("DONTREWRITE", "");
                urlTest = urlTest.replace("DONTREWRITE", "");
                dontRewrite = true;
                console.log("Don't rewrite " + url);
            }
            let splitted = urlTest.split('?');
            urlTest = splitted[0];
            Object.defineProperty(this, 'url', { writable: true });
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore-next-line
            this.url = url;
            // if( !url.includes("&rnpaw=") && !url.includes("?rnpaw=") )
            if (method === "GET" && (urlTest.endsWith(".mpd") || urlTest.endsWith(".mp4") || urlTest.endsWith(".m3u8") || urlTest.endsWith(".ts") || urlTest.endsWith(".m4s"))) {
                Logger.log("XHR-intercepted -> " + url);
                let params;
                if (splitted.length > 1)
                    params = splitted[1];
                url = urlTest;
                let urlObject = new URL(url);
                let newUrl = "";
                if (!dontRewrite) {
                    try {
                        newUrl = cdnBalancer.simpleRequest(urlObject);
                        newUrl = newUrl.trim();
                    }
                    catch (error) { }
                    if (newUrl === "") {
                        newUrl = originalUrl;
                    }
                    else {
                        if (params) {
                            if (newUrl.includes("?")) {
                                newUrl = newUrl + "&" + params;
                            }
                            else {
                                newUrl = newUrl + "?" + params;
                            }
                        }
                    }
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                this.url = newUrl;
                /*  if( newUrl.includes("manifest.m3u8") ){
                   // this.abort();
                    console.log("DETECTED LOADED VIA P2P "+url);
                    console.log(this);
        
                    Object.defineProperty(this, 'response',         {writable: true} );
                    Object.defineProperty(this, 'responseText',     {writable: true} );
                    Object.defineProperty(this, 'status',           {writable: true} );
                    Object.defineProperty(this, 'statusText',       {writable: true} );
                    Object.defineProperty(this, 'readyState',       {writable: true} );
                    Object.defineProperty(this, 'byteLength',       {writable: true} );
        
                    let result = '#EXTM3U'+
                    '#EXT-X-INDEPENDENT-SEGMENTS\n'+
                    '#EXT-X-MEDIA:TYPE=AUDIO,GROUP-ID="audio_group",NAME="Getting Started Encoding UI Audio Group 128kbit",LANGUAGE="null",URI="audio_128000.m3u8"\n'+
                    '#EXT-X-STREAM-INF:BANDWIDTH=4728000,CODECS="avc1.64001F,mp4a.40.2",RESOLUTION=1280x534,AUDIO="audio_group"\n'+
                    'video_2300000.m3u8\n';
                    
                    ( this.responseText as any )  =  result;
                    ( this.status as any )        =  200;
                    ( this.statusText as any )    =  'OK';
                    ( this.readyState as any )    =  this.DONE;
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore-next-line
                    ( this.byteLength as any )    =  200;
        
                    let le = new CustomEvent('loadend', {detail: {foo: 'bar'}});
                    let re = new CustomEvent('readystatechange', {detail: {foo: 'bar'}});
            
                    this.dispatchEvent(le);
                    this.dispatchEvent(re);
        
                 
                  }*/
                this.addEventListener('load', function (e) {
                });
                this.addEventListener('loadstart', function (e) {
                    cdnBalancer.getLoader().loadStartEM(this, urlObject, e);
                });
                let oldReady = this.onreadystatechange;
                this.addEventListener('readystatechange', function () {
                    let isOk = cdnBalancer.getLoader().readyStateChangeEM(this, urlObject);
                    if (isOk === false) {
                        cdnBalancer.openAndSend(this, url);
                    }
                });
                this.addEventListener('progress', function (e) {
                    cdnBalancer.getLoader().progressEM(this, urlObject, e);
                });
                this.addEventListener('loadend', function (e) {
                    cdnBalancer.getLoader().loadEndEM(this, urlObject, e);
                });
                this.addEventListener('error', function (e) {
                });
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                return open.call(this, method, url, ...rest);
            }
            else {
                // let urlObject = new URL(url); 
                // let urlPath = urlObject.pathname;
                Logger.log("XHR-not-intercepted -> " + url);
                //let newUrl = "https://sb-eu-1.npaw.com/test/"+urlPath+"?orresource="+url;
                //newUrl = newUrl.replace("//","/");
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore-next-line
                return open.call(this, method, url, ...rest);
            }
        };
    }
    /**
   * Triggers both direct callback and attached event listeners
   * for the given event.
   */
    /* private trigger< K extends keyof (XMLHttpRequestEventTargetEventMap & { readystatechange: ProgressEvent<XMLHttpRequestEventTarget>})>(eventName: K, object: XMLHttpRequest,options?: ProgressEventInit) {
       // this.log('trigger "%s" (%d)', eventName, this.readyState)
       // this.log('resolve listener for event "%s"', eventName)
  
        // @ts-expect-error XMLHttpRequest class has no index signature.
        const callback = this[`on${eventName}`] as XMLHttpRequestEventHandler
        callback?.call(this, createEvent(this, eventName, options))
  
        for (const event of object._events) {
          if (event.name === eventName) {
            console.log( 'calling mock event listener "%s" (%d)');
            event.listener.call(this, createEvent(object, eventName, options))
          }
        }
  
        return this
      }*/
    openAndSend(request, url) {
        try {
            request.open("GET", url);
            request.send();
        }
        catch (error) {
        }
    }
    /**
     * Redirects adapter's requests to loader.
     * If loader is not ready yet it retries again after 200ms.
     * @param {URL} url URL object for the request.
     * @param {callback} callback Callback method to call back when loaded.
     * @param {Object} headers Optional headers of the request.
     * @param {number} retries Number of retries before giving up to load a segment if it fails, optional.
     * @param {boolean} forceArrayBuffer set as true if is expected to get the manifest response in ArrayBuffer format.
     * @public
     */
    request(url, download, callbacks, headers, retries, forceArrayBuffer, stats) {
        this._loader.processSegment(url, true, callbacks, headers, retries, forceArrayBuffer, stats);
    }
    /**
     * Sets the manifest URL of the played content to the options object.
     * For url changes the loader is restarted.
     * @param {string} url Manifest url of the content being played.
     * @public
     */
    setManifestResource(url) {
        if (url && this.options.resource !== url) {
            this.options.resource = url;
            this._loader = new Loader(this.options);
            this._loader.loadCDNBalancerData();
        }
    }
    getLoader() {
        return this._loader;
    }
    addInterceptor(name, player) {
        this.interceptors.loadInterceptor(name, player);
    }
    simpleRequest(url) {
        Logger.log("Balancing " + url.toString());
        if ((this.options.resource == undefined || this.options.resource === '')) {
            this.setManifestResource(url.toString());
        }
        let segment = this._loader.processSegment(url, false, []);
        // Adding segment to segments maps
        let override = (this.options.overrideManifest && segment.isManifest);
        if (!segment.isManifest)
            override = true;
        let newUrl = override ? segment.finalUrl : segment.url;
        this._loader.segmentsMap.set(newUrl, url.toString());
        return newUrl;
    }
}
